module.exports = __webpack_public_path__ + "static/19.1-2e23fea7068f02b40559fff232c5172c.jpg";